// extracted by css-extract-rspack-plugin
export default {"root":"DODVbj9NHuIf0M_V"};